import { Box, Paper } from '@mui/material';
import React from 'react';
import { fullWidth } from '../../../../../constants/lkCadastr/cadastrStorage';
import { TextTitle } from '../../../../../components/Text';

export function ReportCounter({title, loading, children}) {
  return (
    <Box sx={fullWidth}>
      <Paper elevation={4} sx={{ padding: '20px', mt: '15px', mb: '15px' }}>
        <TextTitle h2="h2">{title}</TextTitle>
        <TextTitle h2="h2">{loading ? 'Загрузка...' : children}</TextTitle>
      </Paper>
    </Box>
  );
}
